import { createAdminResource } from 'lib/admin-kit';
import dealerConfig from './config';

/**
 * Registered as 'pages/admin/dealers/Index' by react-rails via:
 *   require.context('components', true)
 *
 * Mounted from app/views/admin_kit/dealers/index.html.haml with props:
 *   dealerTypes:     Dealer.types
 *   oems:            PortalApp.manufacturers
 *   serviceNetworks: ServiceNetwork.pluck(:name).sort
 */
export default createAdminResource(dealerConfig).Index;
